import React from 'react';
import { CardContent } from '@mui/material';
import { ExploreMoreCardWrapper, CardTitle, Description } from './styles';
import { ViewMoreLink } from '../common/ViewMoreLink';

const EmptyCard = ({ taskId }) => {
  return (
    <ExploreMoreCardWrapper
      sx={{
        maxWidth : { xs: '100%', lg: '400px' },
        minWidth : '240px',
        flex     : 1,
      }}>
      <CardContent>
        <CardTitle
          variant='h6'>No data yet</CardTitle>
        <Description
          variant='pl3'>
          Fill out the core module to get personalized matches
        </Description>
        <ViewMoreLink
          to={`/questionnaire/${taskId}`}>
          Fill core module
        </ViewMoreLink>
      </CardContent>
    </ExploreMoreCardWrapper>
  );
};

export default EmptyCard;
